/**
 * Constant for the store module (or reducer) key.
 *
 * @type {string}
 */
export const STORE_KEY = 'core/reusable-blocks';
